module.exports = __webpack_public_path__ + "static/media/chimney.74056a94.svg";